<template>
    <input
        :id="props.id"
        :autocomplete="props.autocomplete"
        :type="props.type"
        :name="props.name"
        :placeholder="props.placeholder"  
        :disabled="props.disabled"
        :readonly="props.readonly"
        :inputmode="props.inputmode"
        :maxlength="props.maxlength"
        :class="inputClassName"
        :value="inputValue"
        @input="onValueUpdate"
        @blur="onBlur"
        @focus="onFocus"
    >
</template>

<script setup>
    import { computed } from 'vue';
    import { cn } from '../../utils/cn';

    const emits = defineEmits([ 'update:value', 'update:modelValue', 'blur', 'focus' ]);

    const props = defineProps({
        sizeClass: {
            default: 'w-full ',
            type: String
        },
        id: { type: String, default: '' },
        type: { type: String, default: 'text' },
        disabled: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        autocomplete: { type: String, default: 'off' },
        inputmode: { type: String, default: '' },
        maxlength: { type: [String, Number], default: undefined },
        useDefaultStyles: { type: Boolean, default: true },
        hasError: { type: Boolean, default: false },
        value: String,
        modelValue: { type: [String, Number], default: undefined },
        inputClass: { type: [String, Object, Array], default: '' },
        name:  { type: String, default: '' },
        placeholder: { type: String, default: '' } 

  

    });

    const inputValue = computed(() => (
        props.modelValue !== undefined ? props.modelValue : props.value
    ));

    const inputClassName = computed(() => cn(
        props.useDefaultStyles
            ? [
                'bg-white h-12 py-3 px-4 rounded-xl  transition duration-75 border-[1.5px] ease-linear',
                'text-navy placeholder:text-brandNavy-muted outline-none ',
                props.hasError ? 'border-brand-pink focus:border-brand-pink' : 'border-border-field focus:border-brandNavy-muted'
            ]
            : '',
        props.sizeClass,
        props.inputClass
    ));

    function onValueUpdate($event) {
        const nextValue = $event.target.value;
        emits('update:value', nextValue);
        emits('update:modelValue', nextValue);
    }

    function onBlur($event) {
        emits('blur', $event);
    }

    function onFocus($event) {
        emits('focus', $event);
    }
</script>
